import React from 'react';

const sizeToMax = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl'
};

const Modal = ({
    title,
    onClose,
    children,
    footer = null,
    size = 'md',
    centerTitle = false,
    bodyClassName = '',
    panelClassName = ''
}) => {
    const maxW = sizeToMax[size] || sizeToMax.md;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 backdrop-blur-sm px-4" onClick={onClose}>
            <div className={`w-full ${maxW} max-h-[85vh] rounded-2xl border border-slate-200 dark:border-white/10 shadow-2xl overflow-hidden flex flex-col ${panelClassName}`} style={{ backgroundColor: 'var(--bg-surface)', boxShadow: '0 25px 50px var(--shadow-color)' }} onClick={(e) => e.stopPropagation()}>
                {title && (
                    <div className="px-5 py-4 border-b border-slate-200 dark:border-white/10 flex-shrink-0">
                        <div className="flex items-start justify-between">
                            <h2 className={`text-lg font-semibold tracking-tight text-slate-900 dark:text-white ${centerTitle ? 'w-full text-center' : ''}`}>{title}</h2>
                            <button onClick={onClose} className="rounded-full p-1.5 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-white/10 transition shrink-0" aria-label="Close">
                                <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                            </button>
                        </div>
                    </div>
                )}
                <div className={`px-5 py-4 overflow-auto flex-1 min-h-0 ${bodyClassName}`}>
                    {children}
                </div>
                {footer && (
                    <div className="px-5 py-4 border-t border-slate-200 dark:border-white/10 flex-shrink-0">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;


